import React, {useEffect, useRef} from 'react'
import SunEditor from 'suneditor-react'
import 'suneditor/dist/css/suneditor.min.css'
import ErrorMsg from './NewMsgErr'
import MaxCharactersNote from './MaxCharactersNote'

const MyEditorComponent = ({name, change, value, child, errors, characters}: any) => {
  const editorRef = useRef<any>(null)

  const arabicFonts = [
    'Amiri',
    'Scheherazade New',
    'Noto Sans Arabic',
    'Harmattan',
    'Reem Kufi',
    'Cairo',
    'El Messiri',
    'Tajawal',
    'Markazi Text',
    'Lateef',
    'Katibeh',
    'Almarai',
    'Droid Arabic Kufi',
    'Changa',
    'Mada',
    'Rakkas',
    'Lemonada',
    'Aref Ruqaa',
    'Readex Pro',
    'IBM Plex Sans Arabic',
    'Areh',
    'Mirza',
    'Kufam',
    'Baloo Bhaijaan 2',
    'Sonsie One Arabic',
    'Aref Ruqaa Ink',
    'Jomhuria',
    'Vibes',
    'Marhey',
  ]

  const englishFonts = [
    'Open Sans',
    'Lato',
    'Montserrat',
    'Poppins',
    'Roboto',
    'Merriweather',
    'Playfair Display',
    'Source Sans 3',
    'Nunito Sans',
    'PT Sans',
    'Fira Sans',
    'Karla',
    'Libre Baskerville',
    'Work Sans',
    'Cabin',
    'Arvo',
    'EB Garamond',
    'Hind',
    'Comfortaa',
    'Exo 2',
    'Inter',
    'Lora',
    'Manrope',
    'IBM Plex Sans',
    'Outfit',
    'Space Mono',
    'Prompt',
    'Plus Jakarta Sans',
    'Spline Sans',
    'DM Sans',
    'Ubuntu',
    'Cormorant Garamond',
    'Cinzel Decorative',
    'Bodoni Moda',
    'Bellefair',
    'Cardo',
    'Josefin Slab',
    'Crimson Text',
    'Alegreya',
    'Fanwood Text',
    'Prata',
    'Nunito',
    'Quicksand',
    'Kalam',
    'Rubik',
    'Gochi Hand',
    'Patrick Hand',
    'Varela Round',
    'Caveat',
    'Oswald',
    'Bebas Neue',
    'Anton',
    'Alfa Slab One',
    'Michroma',
    'Staatliches',
    'Squada One',
    'Paytone One',
    'Russo One',
    'Lobster Two',
    'Pacifico',
    'Permanent Marker',
    'Great Vibes',
    'Dancing Script',
    'UnifrakturMaguntia',
    'Special Elite',
    'Sacramento',
    'Limelight',
    'Press Start 2P',
    'Shadows Into Light',
    'Metal Mania',
  ]

  const currentValue = value?.[name]?.[child] || ''

  // تحديث محتوى المحرر عند تغيير التاب
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.setContents(currentValue)
    }
  }, [child])

  useEffect(() => {
    if (!value?.[name]?.[child]) {
      change((prev: any) => ({
        ...prev,
        [name]: {
          ...prev?.[name],
          [child]: '',
        },
      }))
    }
  }, [child])

  return (
    <>
      <SunEditor
        getSunEditorInstance={(sunEditor) => {
          editorRef.current = sunEditor
        }}
        defaultValue={currentValue}
        onChange={(content: string) => {
          editorRef.current.latestContent = content
        }}
        onBlur={() => {
          const content = editorRef.current?.getContents?.()

          if (typeof content === 'string') {
            change((prev: any) => ({
              ...prev,
              [name]: {
                ...prev[name],
                [child]: content,
              },
            }))
            console.log(`✅ Saved content ${name}.${child}:`, content)
          } else {
            console.warn(`❌ Failed to get content for ${name}.${child}`)
          }
        }}
        setOptions={{
          buttonList: [
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
            ['removeFormat'],
            ['outdent', 'indent'],
            ['align', 'horizontalRule', 'list', 'table'],
            ['link'],
            ['fullScreen', 'showBlocks', 'codeView'],
            ['preview', 'print'],
          ],
          font: child === 'ar' ? arabicFonts : englishFonts,
        }}
      />

      <MaxCharactersNote characters={characters} />

      {errors && errors[`${name}.${child}`] && typeof errors[`${name}.${child}`] === 'string' && (
        <ErrorMsg msgErr={errors[`${name}.${child}`]} />
      )}
    </>
  )
}

export default MyEditorComponent
